<template>
<div v-if="detections.length > 0" class="table__wrapper">
  <table class="table">
    <thead>
      <tr>
        <th @click="$emit('sort', {col: 'name'})">Specie</th>
        <th @click="$emit('sort', {col: 'device'})">Calls</th>
        <th @click="$emit('sort', {col: 'device'})">Confidence</th>
        <th @click="$emit('sort', {col: 'device'})">Likelihood</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(group, index) in Object.keys(grouped).sort()">
        <td>{{group}}</td>
        <td>{{grouped[group].length}}</td>
        <td>
          {{toPercent(Math.min(...grouped[group].map(item => item.confidence)))}} -
          {{toPercent(Math.max(...grouped[group].map(item => item.confidence)))}} %
        </td>
        <td>{{toPercent(grouped[group][0].location)}}%</td>
      </tr>
    </tbody>
  </table>
</div>
</template>


<script>
var groupBy = require('lodash.groupby');


export default {
    props: {
        detections: {type: Array, default: []},
    },
    methods: {
        toPercent: (val) => Math.round(val * 100)
    },
    computed: {
        grouped() {
            return groupBy(this.detections, "common_name")
        }
    }
}
</script>

<style>
.table__wrapper {
    overflow-x: auto;
}
</style>
